import { useEffect, useState } from "react";
import { fetchTopUsers } from "../services/topUsersService";

export default function useTopUsers(defaultDays = 30, limit = 25) {
	const [range] = useState(() => {
		const end = new Date();
		const start = new Date(end.getTime() - defaultDays * 24 * 60 * 60 * 1000);
		return { start: start.toISOString(), end: end.toISOString() };
	});
	const [data, setData] = useState({ users: [] });
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		let cancelled = false;
		(async () => {
			setLoading(true);
			setError(null);
			try {
				const res = await fetchTopUsers({ start: range.start, end: range.end, limit });
				if (!cancelled) setData(res);
			} catch (e) {
				if (!cancelled) setError(e?.response?.data?.message || e.message || "Failed to load top users");
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => { cancelled = true; };
	}, [range, limit]);

	return { data, loading, error };
}


